import React from 'react';
import ReactDOM from 'react-dom/client';

export class LanguageSwitcher extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            locale: localStorage.getItem('language')
        };

        this.handleCLick = this.handleCLick.bind(this);
    }

    handleCLick() {
        this.setState({isOpen: !this.state.isOpen});
    }

    render() {
        let listClass = "origin-top-right absolute right-0 mt-2 w-12 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5";
        if (!this.state.isOpen) {
            listClass += " hidden";
        }

        let url = new URL(window.location.href);
        let searchParams = url.searchParams;
        searchParams.set('lang', 'ru');
        url.search = searchParams.toString();
        const ruLink = url.toString();

        searchParams.set('lang', 'et');
        url.search = searchParams.toString();
        const etLink = url.toString();

        return <>
            <div className="relative inline-block text-left">
                <button
                    className="inline-flex justify-center items-center px-2 py-2  focus:outline-none outline-none uppercase"
                    id="options-menu" aria-haspopup="true" aria-expanded="true" onClick={this.handleCLick}>
                    {this.state.locale}
                    <svg className="-mr-1 ml-2" width="10" height="6" viewBox="0 0 10 6" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M9.53033 0.46967C9.82322 0.762563 9.82322 1.23744 9.53033 1.53033L5.53033 5.53033C5.23744 5.82322 4.76256 5.82322 4.46967 5.53033L0.46967 1.53033C0.176777 1.23744 0.176777 0.762564 0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L5 3.93934L8.46967 0.46967C8.76256 0.176777 9.23744 0.176777 9.53033 0.46967Z"
                              fill="#333333"/>
                    </svg>
                </button>

                <div
                    className={listClass}
                    aria-labelledby="options-menu" role="menu">
                    <div className="py-1" role="none">
                        <a href={ruLink}
                           className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 !text-black"
                           role="menuitem">RU</a>
                        <a href={etLink}
                           className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 !text-black"
                           role="menuitem">ET</a>

                    </div>
                </div>
            </div>
        </>;
    }
}

if (document.getElementById('lang-switcher')) {
    const root = ReactDOM.createRoot(document.getElementById('lang-switcher'));
    root.render(<LanguageSwitcher />);
}
